<template>
  <EntityList
    :config="config"
    :columns="columns"
    :filter-vals.sync="filterVals"
    :filters="filters"
    :formatted-columns="formattedColumns"
    :extra-actions="extraActions"
    authority="General_Promotion"
    single-edit
    desc-sort
  />
</template>

<script>
import { getUserRights } from '@/auth/utils'
import EntityList from '@/layouts/entity/EntityList.vue'

import storeModule from '../promotionStoreModule'

export default {
  components: {
    EntityList,
  },
  data() {
    return {
      filterVals: [],
      categoryOptions: [],
    }
  },
  computed: {
    config() {
      return {
        store: storeModule,
        module: 'promotions',
        endpoint: 'promotions',
        route: 'promotions',
        title: {
          single: this.$i18n.t('Promotion'),
          plural: this.$i18n.t('Promotions'),
        },
      }
    },
    columns() {
      return [
        { key: 'id', label: this.$t('id'), sortable: true },
        { key: 'title', label: this.$t('title'), sortable: true },
        { key: 'creationDate', label: this.$t('Creation Date'), sortable: true },
        { key: 'startDate', label: this.$t('start date'), sortable: false },
        { key: 'endDate', label: this.$t('end date'), sortable: false },
        { key: 'categories', label: this.$t('category'), sortable: false },
        { key: 'enabled', label: this.$t('enabled') },
        { key: 'actions', label: this.$t('actions') },
      ]
    },
    formattedColumns() {
      return [
        { key: 'enabled', type: 'boolean' },
        { key: 'creationDate', type: 'datetime' },
        { key: 'startDate', type: 'date' },
        { key: 'endDate', type: 'date' },
        { key: 'categories', type: 'list' },
      ]
    },
    extraActions() {
      const rights = getUserRights()

      return [
        {
          endpoint: 'eshop/promotion-publish',
          icon: 'UploadCloudIcon',
          title: 'Publish to e-shop',
          // @TODO this needs to be added in the back
          renderCondition: {
            key: 'isOnline',
            value: false,
          },
          authorityValidation: rights.includes('General_Promotion_Publish_Edit'),
        },
      ]
    },

    filters() {
      return [
        {
          name: 'startedfrom',
          type: 'date',
          label: this.$i18n.t('Started From'),
          value: null,
        },
        {
          name: 'endedto',
          type: 'date',
          label: this.$i18n.t('Ended To'),
          value: null,
          minDateFieldIdx: '0',
        },
        {
          name: 'enabled',
          type: 'boolean',
          label: this.$i18n.t('Enabled'),
          value: null,
        },
        {
          name: 'category',
          label: this.$t('category'),
          options: this.categoryOptions,
          value: null,
        },
      ]
    },
  },
  mounted() {
    this.$store.dispatch('app-common/fetchPostCategories').then(response => {
      this.categoryOptions = response.data
    })
  },
}
</script>
